import store from '@/store';
import { apiCall } from './apiCall';
import { errorToast } from './helper';

let walletBalanceTimer = null;

const getWalletBalance = async ( ) => {
    if (store.getters.walletPollingPaused) return;
    
    try {
        const response = await apiCall( 'post','WALLET_BALANCE');
        if (response?.status === 200 && response?.data) {
            let user = store.getters.stateUser;
            if (!user) return;

            user.balance = response?.data?.bl;
            user.expl = response?.data?.ex;
            user.earnBonus = response?.data?.eb;
            user.bets_count = response?.data?.bc;

            store.dispatch('setUser', user);
            walletBalanceTimer = setTimeout(() => {
                getWalletBalance();
            }, 4000);
        } else {
            window.cookies.keys().forEach(cookie => window.cookies.remove(cookie))
            store.dispatch('resetAllState');
        }

    } catch (error) {
        if (error) {
            errorToast(error[0]);
        }
        if (!error || error.retry) {
            clearTimeout(walletBalanceTimer);
            walletBalanceTimer = setTimeout(() => {
                getWalletBalance();
            }, 4000);
        }
    }
};

const stopWalletPolling = () => {
    store.dispatch('setWalletPolling', true);
    clearTimeout(walletBalanceTimer);
    walletBalanceTimer = null;
};

const startWalletPolling = () => {
    store.dispatch('setWalletPolling', false);
    clearTimeout(walletBalanceTimer);

    walletBalanceTimer = setTimeout(() => {
        getWalletBalance();
    }, 4000);
};

export { getWalletBalance, startWalletPolling, stopWalletPolling };